var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wind-profile-chart',{on:{"wind-profile-chart-ready":_vm.onWindProfileChartReady,"wind-profile-chart-destroy":_vm.onWindProfileChartDestroy}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da6d975c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/ChartWrapper/WindProfileChartWrapper.vue
// module id = null
// module chunks = 